export type FunnelType = 'default' | 'mt' | 'rb' | 'ff' | 'fa' | 'three_in_one';

export enum PAGES {
  QUIZ_PAGE = 'quiz',
  QUIZ_SUMMARY_PAGE = 'quiz_summary',
  EMAIL_PAGE = 'em',
  LOADER_PAGE = 'loader',
  SALES_PAGE = 'p',
  UPSELL_PAGE = 'ups',
  THANK_YOU_PAGE = 'thank-you',
}

export enum USER {
  ID = 'user_id',
  TIMER = 'user_timer',
  DOWNSELL = 'user_downsell',
  UPSELL_DOWNSELL = 'user_upsell_downsell',
  FREE_PDF = 'user_fpdf',
  ANSWERS = 'answers',
  TESTS = 'tests',
  PAYMENT_TYPE = 'payment_type',
}

export enum PaymentType {
  CARD = 'card',
  APPLE_PAY = 'apple_pay',
  PAYPAL = 'paypal',
}

export enum PaymentMode {
  PDF_ONETIME = 'pdf_onetime',
  PDF_ONETIME_2 = 'pdf_onetime_2',
  PDF_SUBSCRIPTION = 'pdf_subscription',
  PDF_SUBSCRIPTION_WITH_TRIAL = 'pdf_subscription_with_trial',
  MANIFEST_SUBSCRIPTION = 'manifest_subscription',
  MANIFEST_SUBSCRIPTION_WITH_TRIAL = 'manifest_subscription_with_trial',
  SESSION_ONETIME = 'session_onetime',
}

export enum PaymentFormula {
  TRIAL = 'trial',
  SUBSCRIPTION = 'subscription',
  ONETIME = 'onetime',
}

export interface Time {
  hours: number;
  minutes: number;
  seconds: number;
}

export type Price = Record<
  'sales' | 'checkout',
  Record<'full' | 'period', Record<'old' | 'current', JSX.Element>>
>;

interface BaseProduct {
  name: string;
  paymentType: PaymentMode;
}

export interface PDF extends BaseProduct {
  downloadLink: string;
  smallImg: string;
  largeImg: string;
}

export interface Session extends BaseProduct {
  bookingLink: string;
  smallImg: string;
  largeImg: string;
  link?: string;
}

export type Application = BaseProduct;

export type Product = Application | PDF | Session;

export interface Total {
  productId: string;
  basePlanId: string;
  trialDays: number;
  firstPayment: number;
  secondPayment: number;
  products: Product[];
  formula: PaymentFormula;
  orderDescription?: string;
}

export type UserOrder = Record<any, any>;

export interface UserOrders {
  manifestSubs: UserOrder[];
  pdfSubs: PDF[];
  pdfOnetime: PDF[];
  sessionOnetime: Session[];
}

export interface PlanName {
  sales: string | JSX.Element;
  checkout: string | JSX.Element;
}

export type AnimationType =
  | 'pulse_red'
  | 'pulse_white'
  | 'pulse_black'
  | 'pulse_golden';

export type LogoColor = 'purple_gradient' | 'black' | 'none';

export type BeforeAfterType = 'before' | 'after';

export interface LinearGraphElement {
  id: number;
  title: string;
  diagramType: 'linear';
  value: number;
  maxValue: number;
  backgroundType: 'color' | 'image';
  outerWrapperBcg: string;
  innerWrapperBcg: string;
}

export interface GadialGraphElement {
  id: number;
  title: string;
  diagramType: 'radial';
  value: number;
  backgroundInfo: CircleLoaderBackgroundType;
}

export type CircleLoaderBackgroundType = {
  backgroundId: string;
  backgroundCode: JSX.Element;
  outerBgColor: string;
};

export interface UpsellPlan {
  plan: Total;
  title: JSX.Element;
  subtitle: JSX.Element;
  oldPrice: JSX.Element;
  currentPrice: JSX.Element;
  discount: JSX.Element;
  list: {
    id: number;
    icon: string;
    text: JSX.Element;
  }[];
  img: string;
  subscriptionInfo: JSX.Element | null;
}

export enum OrderStatus {
  Created = 'created',
  Processing = 'processing',
  ThreeDsVerify = '3ds_verify',
  SettlePending = 'settle_pending',
  AuthOk = 'auth_ok',
  AuthFailed = 'auth_failed',
  VoidOk = 'void_ok',
  Approved = 'approved',
  Declined = 'declined',
  SettleOk = 'settle_ok',
  PartialSettled = 'partial_settled',
  Refunded = 'refunded',
}

export const failedOrderStatuses = [
  OrderStatus.Declined,
  OrderStatus.AuthFailed,
];
